import SuccessRatePercent from "./SuccessRatePercent";

export default class SuccessRates {
    public overallPercent: number;
    public byFootballCompetition: Record<string, SuccessRatePercent>;
    public byFootballTeam: Record<string, SuccessRatePercent>;
    public byFootballMarket: Record<string, SuccessRatePercent>;
}